import axios from 'axios'

export default {
  namespaced: true,
  state: {
    recebExcluidas: [],
    pagarExcluidas: [],
    
    // Filtros Receber
    recebFiltroDataInicial: '',
    recebFiltroDataFinal: '',
    recebFiltroTipoData: 'DT_CANC',
    
    // Filtros Pagar
    pagarFiltroDataInicial: '',
    pagarFiltroDataFinal: '',
    pagarFiltroTipoData: 'DT_CANC',

    recarregarLista: false
  },
  getters: {
    RECEB_EXCLUIDAS: state => state.recebExcluidas,
    PAGAR_EXCLUIDAS: state => state.pagarExcluidas,
    
    RECEB_FILTRO_DATA_INICIAL: state => state.recebFiltroDataInicial,
    RECEB_FILTRO_DATA_FINAL: state => state.recebFiltroDataFinal,
    RECEB_FILTRO_TIPO_DATA: state => state.recebFiltroTipoData,
    
    PAGAR_FILTRO_DATA_INICIAL: state => state.pagarFiltroDataInicial,
    PAGAR_FILTRO_DATA_FINAL: state => state.pagarFiltroDataFinal,
    PAGAR_FILTRO_TIPO_DATA: state => state.pagarFiltroTipoData,

    RECARREGAR_LISTA: state => state.recarregarLista
  },
  mutations: {
    SET_RECEB_EXCLUIDAS(state, payload) {
      state.recebExcluidas = payload
    },
    SET_PAGAR_EXCLUIDAS(state, payload) {
      state.pagarExcluidas = payload
    },
    SET_RECEB_FILTRO_DATA_INICIAL(state, payload) {
      state.recebFiltroDataInicial = payload
    },
    SET_RECEB_FILTRO_DATA_FINAL(state, payload) {
      state.recebFiltroDataFinal = payload
    },
    SET_RECEB_FILTRO_TIPO_DATA(state, payload) {
      state.recebFiltroTipoData = payload || 'DT_CANC'
    },
    SET_PAGAR_FILTRO_DATA_INICIAL(state, payload) {
      state.pagarFiltroDataInicial = payload
    },
    SET_PAGAR_FILTRO_DATA_FINAL(state, payload) {
      state.pagarFiltroDataFinal = payload
    },
    SET_PAGAR_FILTRO_TIPO_DATA(state, payload) {
      state.pagarFiltroTipoData = payload || 'DT_CANC'
    },
    SET_RECARREGAR_LISTA(state, payload) {
      state.recarregarLista = payload
    },
    SET_LIMPAR_RECEB(state) {
      state.recebFiltroDataInicial = ''
      state.recebFiltroDataFinal = ''
      state.recebFiltroTipoData = 'DT_CANC'
    },
    SET_LIMPAR_PAGAR(state) {
      state.pagarFiltroDataInicial = ''
      state.pagarFiltroDataFinal = ''
      state.pagarFiltroTipoData = 'DT_CANC'
    }
  },
  actions: {
    async GET_RECEB_EXCLUIDAS(context) {
      const { data } = await axios.post('/api/protected/auditoria/areceber-excluidas/pesquisar', {
        dt1: context.state.recebFiltroDataInicial,
        dt2: context.state.recebFiltroDataFinal,
        tipoData: context.state.recebFiltroTipoData
      })
      context.commit('SET_RECEB_EXCLUIDAS', data)
      return data
    },
    async GET_PAGAR_EXCLUIDAS(context) {
      const { data } = await axios.post('/api/protected/auditoria/apagar-excluidas/pesquisar', {
        dt1: context.state.pagarFiltroDataInicial,
        dt2: context.state.pagarFiltroDataFinal,
        tipoData: context.state.pagarFiltroTipoData
      })
      context.commit('SET_PAGAR_EXCLUIDAS', data)
      return data
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/auditoria-store.js